import { computed } from 'vue';
import { usePermissions } from '@/composables/usePermissions';

export const menuItems = [
  {
    title: "Reportes da IA",
    icon: "fa-solid fa-robot",
    value: "ticket",
    route: "/ticket",
    permission: "ticket" // Nome da permissão necessária
  },
  {
    title: "Arquivos",
    icon: "fa-solid fa-file",
    value: "files",
    route: "/files",
    permission: "files"
  },
  {
    title: "Base Conhecimento da IA",
    icon: "fa-solid fa-gear",
    value: "config",
    route: "/config",
    permission: "config"
  },
  {
    title: "Transferencias",
    icon: "fas fa-exchange-alt",
    value: "transfers",
    route: "/transfer",
    permission: "transfers"
  },
  {
    title: "Financeiro",
    icon: "fas fa-file-invoice-dollar",
    value: "financer",
    route: "/financer",
    permission: "financer"
  },
  {
    title: "Usuários",
    icon: "fas fa-users",
    value: "residents",
    route: "/usuarios",
    permission: "residents"
  },
  {
    title: "Tarefas",
    icon: "fas fa-tasks",
    value: "calendar",
    route: "/tarefas",
    permission: "calendar"
  },
  {
    title: "Chat",
    icon: "fa-solid fa-comment",
    value: "settings",
    route: "/chat",
    permission: "settings"
  },
  {
    title: "Conexões WhatsApp",
    icon: "fa-brands fa-square-whatsapp",
    value: "config-wpp",
    route: "/config-wpp",
    permission: "config-wpp"
  },
  {
    title: "Sicon GPT",
    icon: "fa-solid fa-comments",
    value: "sicon-gpt",
    route: "/sicon-gpt",
    permission: "sicon-gpt"
  }
];

// Composable para menu filtrado
export function useFilteredMenu() {
  const { userPermissions, hasPermission } = usePermissions();

  // Menu filtrado baseado nas permissões do usuário
  const filteredMenuItems = computed(() => {
    return menuItems.filter(item => {
      // Se não tem propriedade permission, mostra o item (para itens públicos)
      if (!item.permission) {
        return true;
      }
      // Verifica se o usuário tem permissão para este item
      return hasPermission(item.permission);
    });
  });

  return {
    menuItems: filteredMenuItems,
    userPermissions
  };
}
